var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEqual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9.2220955mm",
    height: "8.6326456mm",
    viewBox: "0 0 9.2220955 8.6326456",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-292.20176,-209.97473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "matrix(1.6975572,0,0,1.6975572,-212.69053,-156.22253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "matrix(0.91438163,0,0,0.91438163,24.689719,18.320127)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656565",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.321049,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "m 298.27057,216.06166 0.14019,1.96578 5.78647,-0.26634 -0.14156,-1.87749 z",
    id: "path13-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656565",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.321049,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "m 298.28516,219.47933 0.14019,1.96578 5.78647,-0.26634 -0.14156,-1.87749 z",
    id: "path13-8-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqual);
export default __webpack_public_path__ + "static/media/Equal.353ccbfe02fc1dda7556cf7856e3ab0b.svg";
export { ForwardRef as ReactComponent };